"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _syncBannerStatus = _interopRequireDefault(require("../../../actions/banner/syncBannerStatus"));
var _actionUtils = require("../../../utils/actionUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function bannerLiveToggled(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var bannerId = _ref2.bannerId,
    notifyingDirector = _ref2.notifyingDirector;
  if (!(0, _actionUtils.isSameAttendee)(notifyingDirector, getState())) {
    dispatch((0, _syncBannerStatus["default"])(bannerId));
  }
}
var _default = exports["default"] = bannerLiveToggled;